import { splitHighlight } from "../../data/blog";

/**
 * @param {{ text: string, query: string, className?: string }} props
 */
export default function HighlightText({ text, query, className }) {
  const parts = splitHighlight(text, query);

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.match ? (
          <mark key={index} className="blog-mark">
            {part.text}
          </mark>
        ) : (
          part.text
        )
      )}
    </span>
  );
}
